(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _storyblok_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9036);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_SignupModal_SignupModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6290);
/* harmony import */ var _context_UIContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6849);
/* harmony import */ var _components_JoinFlowInfoModal_JoinFlowInfoModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7425);
/* harmony import */ var _hooks_useTmSignOut__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5473);
/* harmony import */ var _hooks_useStartSignup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3778);
/* harmony import */ var _hooks_useStartVerifyEmail__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6374);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7294);










var __N_SSG = true;
function Home(param) {
    var story = param.story, preview = param.preview, newsStoriesData = param.newsStoriesData, proTournaments = param.proTournaments, teaserRowTournament = param.teaserRowTournament;
    var ref, ref1;
    story = (0,_storyblok_react__WEBPACK_IMPORTED_MODULE_1__/* .useStoryblokState */ .f0)(story, {}, preview);
    var ref2 = (0,_context_UIContext__WEBPACK_IMPORTED_MODULE_4__/* .useUI */ .l)(), uiState = ref2.state;
    var ref3 = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.useSession)(), session = ref3.data;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(""), verifyEmailFlow = ref4[0], setVerifyEmailFlow = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(""), ygbActive = ref5[0], setYgbActive = ref5[1];
    (0,_hooks_useTmSignOut__WEBPACK_IMPORTED_MODULE_6__/* .useTmSignOut */ .y)();
    (0,_hooks_useStartSignup__WEBPACK_IMPORTED_MODULE_7__/* .useStartSignup */ .c)();
    (0,_hooks_useStartVerifyEmail__WEBPACK_IMPORTED_MODULE_8__/* .useStartVerifyEmail */ .M)();
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        if (verifyEmailFlow !== window.localStorage.getItem("verify_email_flow")) {
            setVerifyEmailFlow(window.localStorage.getItem("verify_email_flow"));
        }
        if (ygbActive !== window.localStorage.getItem("ygb_active")) {
            setYgbActive(window.localStorage.getItem("ygb_active"));
        }
    }, [
        uiState
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SignupModal_SignupModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                isOpen: uiState.isSignupModalOpen && ygbActive === "true" && (session === null || session === void 0 ? void 0 : session.accessToken),
                tmToken: session === null || session === void 0 ? void 0 : session.accessToken,
                idTokenHint: session === null || session === void 0 ? void 0 : session.idToken
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_JoinFlowInfoModal_JoinFlowInfoModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                isOpen: uiState.joinFlowInfoModal.isOpen && ((session === null || session === void 0 ? void 0 : session.accessToken) && !uiState.isEmailVerified && verifyEmailFlow === "true" && uiState.joinFlowInfoModal.modalType === "email" || uiState.joinFlowInfoModal.modalType === "signup"),
                tmToken: session === null || session === void 0 ? void 0 : session.accessToken,
                idTokenHint: session === null || session === void 0 ? void 0 : session.idToken
            }),
            story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.map(function(c) {
                if (c.component === "teaser_row") {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_react__WEBPACK_IMPORTED_MODULE_1__/* .StoryblokComponent */ .Xj, {
                        blok: c,
                        tournament: teaserRowTournament
                    }, c._uid);
                }
                if (c.component === "blog_posts_overview") {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_react__WEBPACK_IMPORTED_MODULE_1__/* .StoryblokComponent */ .Xj, {
                        blok: c,
                        stories: newsStoriesData.stories,
                        isFirstPostLarge: false
                    }, c._uid);
                }
                if (c.component === "tournament_card_overview" && (proTournaments === null || proTournaments === void 0 ? void 0 : proTournaments.length) > 0) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_react__WEBPACK_IMPORTED_MODULE_1__/* .StoryblokComponent */ .Xj, {
                        blok: c,
                        story: story,
                        tournaments: proTournaments
                    }, c._uid);
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_react__WEBPACK_IMPORTED_MODULE_1__/* .StoryblokComponent */ .Xj, {
                    blok: c
                }, c._uid);
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [101,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);